import moment from 'moment';
import { take, takeLast } from 'ramda';

export const formatDate = (date?: Date) => moment(date).format('MM/DD/YYYY');

export const formatDateForReport = (date?: Date) => moment(date).format('DD-MM-YYYY');

export const getYear = (date: Date) => moment(date).format('YY');

export const getFullYear = (date: Date) => moment(date).format('YYYY');

export const getYearWithMonth = (date: Date) => moment(date).format('MM/YYYY');

export const getDaysDiff = (startDate: Date, endDate?: Date) => moment(endDate || new Date()).diff(startDate, 'days');

export const stringToDate = (date: string) => {
  const month = Number(take(2, String(date)));
  const year = Number(takeLast(4, String(date)));
  return new Date(year, month - 1);
};

export const checkValidDate = (value: string) => {
  const date = stringToDate(value as string);
  const month = Number(take(2, String(value)));
  if (date < new Date() && month > 0 && month < 13) {
    return true;
  }
  return false;
};
